import React from "react";

export default function OurProcess() {
  return (
    <section className="px-4 py-16 max-w-7xl mx-auto">
      <div className="text-center mb-10">
        <button className="text-sm px-3 py-1 bg-gray-100 rounded-full mb-3">
          Our Process
        </button>
        <h2 className="text-4xl md:text-5xl font-bold mb-2">
          A smarter way to work
        </h2>
        <p className="text-gray-500 max-w-xl mx-auto">
          Simplify project planning, streamline collaboration, and boost
          productivity all with Pixell task management solution
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-[#F9F9F9] rounded-2xl p-6 text-center shadow">
          <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-purple-100 rounded-full">
            <img
              src="/assests/images/LandingPage/process1.webp"
              alt="process 1"
            />
          </div>
          <h3 className="text-lg font-bold mb-2">Increased productivity</h3>
          <p className="text-gray-500 text-sm">
            Pixell streamlines your workflow, helping you prioritize tasks, set
            deadlines.
          </p>
        </div>

        <div className="bg-[#F9F9F9] rounded-2xl p-6 text-center shadow">
          <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-blue-100 rounded-full">
            <img
              src="/assests/images/LandingPage/process2.webp"
              alt="process 2"
            />
          </div>
          <h3 className="text-lg font-bold mb-2">Enhanced collaboration</h3>
          <p className="text-gray-500 text-sm">
            Pixell facilitates seamless collaboration among team members.
          </p>
        </div>

        <div className="bg-[#F9F9F9] rounded-2xl p-6 text-center shadow">
          <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-yellow-100 rounded-full">
            <img
              src="/assests/images/LandingPage/process3.webp"
              alt="process 3"
            />
          </div>
          <h3 className="text-lg font-bold mb-2">Improved time management</h3>
          <p className="text-gray-500 text-sm">
            By providing a centralized platform for organizing and managing
            tasks.
          </p>
        </div>
      </div>
    </section>
  );
}
